var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChinese(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 23,
    viewBox: "0 0 31 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_172_507)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H31V23H0V0Z",
    fill: "#EE1C25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7192 8.51078L5.81168 2.30078L7.90415 8.51078L2.32422 4.71578H9.29913L3.7192 8.51078Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7961 2.41841L10.6427 2.89049L12.0791 1.23465L11.9383 3.46319L10.7432 1.49026L12.7961 2.41841Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9688 5.1432L12.7989 4.75213L14.772 3.777L13.7685 5.77706L13.4405 3.50006L14.9688 5.1432Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6514 8.96676L12.8314 7.73417L15.035 7.63995L13.2941 9.06119L13.9334 6.84985L14.6514 8.96676Z",
    fill: "#FFFF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9143 11.4639L10.7168 9.63155L12.7862 10.3866L10.6255 11.0324L12.0785 9.23691L11.9143 11.4639Z",
    fill: "#FFFF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_172_507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinese);
export default __webpack_public_path__ + "static/media/Chinese.e2a6486e934787b6a626d13a07765cb0.svg";
export { ForwardRef as ReactComponent };